const listsTypes = {
    orderedList: 'ordered_list',
    bulletList: 'bullet_list',
    listItem: 'list_item'
};
/**
 * The object of the OrderedList tool settings.
 */
const orderedList = {
    listType: listsTypes.orderedList,
    types: { ...listsTypes }
};
/**
 * The object of the UnorderedList tool settings.
 */
const bulletList = {
    listType: listsTypes.bulletList,
    types: { ...listsTypes }
};

export { bulletList, listsTypes, orderedList };
